
import { Component, Prop, Vue } from "vue-property-decorator";
import { Candidate, CandidateResult, Answer } from "@/lib/model/exam/result";
import DescribeData from "@/views/paper/paper-result-report/component/describe.vue";

@Component({ components: { DescribeData } })
export default class Psychological extends Vue {
  @Prop() index!: number;
  @Prop({ type: CandidateResult, default: () => new CandidateResult() })
  all!: CandidateResult; //候选人信息 所有表
  @Prop({ type: Candidate, default: () => new Candidate() })
  candidate!: CandidateResult; //候选人信息 主表

  get gameQi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 1;
    });
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }
  // 标签
  get tag() {
    if (this.gameQi.balloonData.cognitiveAbilityScore <= 4) {
      return "较低";
    } else if (this.gameQi.balloonData.cognitiveAbilityScore >= 6) {
      return "较高";
    } else return "正常";
  }
  // 其他
  get other() {
    return this.gameQi.balloonData.cognitiveAbilityScore >= 8;
  }
}
